import React, {Component} from 'react';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import classes from './MiscSearchButton.module.css';
import Group from '@material-ui/icons/Group';
import {connect} from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";


class MiscSearchButton extends Component {


    viewMiscSearchPanel = () => {
        this.props.onOpenModal();
    }

    render() {
        return (
            <>
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    rootClose
                    rootCloseEvent="click"
                    key={'super-admin-button'}
                    placement='bottom'
                    overlay={
                        <Popover id={'super-admin-popover'}>
                            <Popover.Title as="h3">User and Group Search</Popover.Title>
                            <Popover.Content className="pattern-exercise-description">
                                Click here to search for Pattern Library users and groups
                            </Popover.Content>
                        </Popover>
                    }
                >
                    <div
                        className={classes.miscSearchButton + ' ' + classes.clickable}
                        key={'super-admin-icon'}
                        onClick={this.viewMiscSearchPanel}
                    >
                        <Group/>
                    </div>
                </OverlayTrigger>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
         onOpenModal: () => dispatch({type: actionTypes.OPEN_MISC_SEARCH_MODAL})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiscSearchButton);